<script>
    export default {
        props: [],
        data() {
            return {
                total: 0,
                discount: 0,
                tabIndex: 1
            }
        },
        created() {
            var self = this;

            this.$bus.$on('go-ahead', function (fr) {
                self.goAhead(fr);
            });
            this.$bus.$on('total-updated', function (total) {
                self.total = total;
            });

            this.$bus.$on('discount-applied', function (discount) {
                self.discount = discount;
            });
        },
        methods: {
            goAhead(fr) {
                $('[tabindex="' + fr + '"]').removeClass('disabled');
                $('[tabindex="' + fr + '"]').tab('show');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/cart/CartTabs.vue